import httpClient from '@/utils/httpClient'
import {
  GenerateWaybillsResponse,
  GetAllWaybillsResponse,
} from 'rikroot-types/schedule/atimo_waybills.pb'

export class WaybillsRepository extends httpClient {
  public async getWaybills(scheduleID: string) {
    // return AtimoWaybillService.GetAllWaybills({ id: scheduleID }, { pathPrefix: ROOT_CONFIG.api_url_v2 })

    const response = await this.get(`/schedule/waybills/${scheduleID}`)

    return response as GetAllWaybillsResponse
  }

  public async generateWaybills(shiftIDs: string[]): Promise<GenerateWaybillsResponse> {
    // return AtimoWaybillService.GenerateWaybills({ ids: shiftIDs }, { pathPrefix: ROOT_CONFIG.api_url_v2 })

    const response = await this.post('/schedule/waybills', { ids: shiftIDs })

    return response as GenerateWaybillsResponse

    // const testResponse = {
    //   waybills: [
    //     ...shiftIDs.map((id) => {
    //       return {
    //         id,
    //         pdfBase64: testWaybillContent,
    //         shiftId: id
    //       }
    //     })
    //   ]
    // }
    //
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve(testResponse)
    //   }, 1000)
    // })
  }
}
